import { getLanguage, getRTL } from "@fluentui/react";
import { IconName } from "./icons";

/** Gets whether the user's display language uses right-to-left (RTL) text */
export const isRTL = (): boolean => {
    return getRTL();
};

/** Gets whether the user's display language uses right-to-left (RTL) text */
export const getRTLIcon = (iconName: IconName): IconName => {
    if (isRTL()) {
        switch (iconName) {
            case "ChevronLeft": return "ChevronRight";
            case "ChevronRight": return "ChevronLeft";
            case "ChevronLeftSmall": return "ChevronRightSmall";
            case "ChevronRightSmall": return "ChevronLeftSmall";
            case "ChevronRightMed": return "ChevronLeftMed";
            case "ChevronLeftMed": return "ChevronRightMed";
            // when we add more to flip, they'll go here
            default: return iconName;
        }
    }
    return iconName;
};

/** Gets the display language of user */
export const userDisplayLanguage = (): string => {
    return getLanguage() || navigator.language;
};
